/**
 * A directive that turns the element into a target for dropping
 * a payload.
 * @example
 * <div apex-drag-drop-container="timeslots"
 *      on-drop-payload="$ctrl.log('Slot 1 says ' + $event.payload.msg)">
 *      <div apex-drag-drop-payload
 *           payload-model="{ msg: 'Hello world' }">
 *      </div>
 * </div>
 * <div apex-drag-drop-container="timeslots"
 *      on-drop-payload="$ctrl.log('Slot 2 says ' + $event.payload.msg)">
 * </div>
 * <div apex-drag-drop-container="invalid"
 *      on-drop-payload="$ctrl.log('Impossible')">
 * </div>
 */
export function DragDropContainerDirective() {
    return {
        restrict: "A",
        scope: {
            disableDragDrop : "<",
            dropPayload: "&onDropPayload", // Handle the drop event. { dragContainer, payload } = $event
            // Allow hooking into the JS API.
            dragEnter: "&onDragEnter",
            dragOver: "&onDragOver",
            dragLeave: "&onDragLeave"
        },
        controller: class DragDropContainerController { },
        controllerAs: "$ctrl",
        bindToController: true,
        link: function (scope, el, attrs) {
            const vm = scope.$ctrl;
            vm.group = attrs.apexDragDropContainer;
            if (!vm.disableDragDrop) {
                el[0].addEventListener("dragover", function (ev) {
                    ev.preventDefault();
                    // Allow the payload to be dragged into this element.
                    el[0].classList.add("dragdrop-over");
                    scope.$apply(function () {
                        vm.dragOver({
                            $event: ev
                        });
                    });
                });
                el[0].addEventListener("dragenter", function (ev) {
                    ev.preventDefault();
                    el[0].classList.add("dragdrop-over");
                    scope.$apply(function () {
                        vm.dragEnter({
                            $event: ev
                        });
                    });
                });
                el[0].addEventListener("dragleave", function (ev) {
                    ev.preventDefault();
                    el[0].classList.remove("dragdrop-over");
                    scope.$apply(function () {
                        vm.dragLeave({
                            $event: ev
                        });
                    });
                });
                el[0].addEventListener("drop", function (ev) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    el[0].classList.remove("dragdrop-over");
                    scope.$apply(function () {
                        const data = JSON.parse(ev.dataTransfer.getData("application/json") || "");
                        if (!data) {
                            return;
                        }
                        if (data && data.group === vm.group) {
                            // Indicate whether the drop was a move, copy, link, or none.
                            data.dropEffect = ev.dataTransfer.dropEffect;
                            vm.dropPayload({
                                $event: data
                            });
                        }
                    })
                })
            }
        }
    }
}
